import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router';
import { isEmpty } from 'lodash';
import PromoValue from './PromoValue';
import GlobalErrorAndRedirectionListener from '../../components/GlobalErrorAndRedirectionListener';
import Loader from '../../components/Loader';

const ensureHttps = (htmlString) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  const anchors = doc.querySelectorAll('a[href]');
  anchors.forEach((anchor) => {
    const hrefValue = anchor.getAttribute('href');
    // Check if hrefValue does not start with a protocol (http, https, ftp, etc.)
    if (!/^(\w+:)?\/\//.test(hrefValue)) {
      anchor.setAttribute('href', 'https://'.concat(hrefValue));
    }
  });
  return doc.body.innerHTML;
};

const CampaignEmail = ({
  loading,
  logo,
  shopName,
  shopAddress,
  backgroundImage,
  color,
  subject,
  body,
  promo,
  unsubscribeUrl,
  goToBookAppointment,
}) => (
  <div className="c-campaign-email-wrapper">
    <GlobalErrorAndRedirectionListener />
    <Helmet>
      <title>Campaign</title>
    </Helmet>
    {loading && <Loader />}
    {!loading && (
      <div className="c-campaign-email">
        <div className="c-campaign-email__header" style={{ color, backgroundImage: `url(${backgroundImage})` }}>
          {logo && <img className="c-logo" src={logo} alt="" />}
          {logo && <div className="u-co-white u-mt-">{shopName}</div>}
        </div>
        <div className="c-campaign-email__body">
          { /* eslint-disable react/no-danger */ }
          { /* html is sinitized on API so we can trust this data */ }
          <div className="delta u-type--normal u-mb-" dangerouslySetInnerHTML={{ __html: subject }} />
          <div dangerouslySetInnerHTML={{ __html: ensureHttps(body) }} />
          { /* eslint-enable react/no-danger */ }
          {!isEmpty(promo) && (
            <div className="u-type--normal u-p u-mt" style={{ backgroundColor: color, borderRadius: 2, color: '#fff' }}>
              <div className="u-type--bold" style={{ fontSize: 22 }}>
                <PromoValue promo={promo} />
              </div>
              <div className="u-type--bold u-mt-">Get <PromoValue promo={promo} /> off next time you visit!</div>
              <div className="u-mt-">
                Book an appointment {promo.expirationDate && <span>by <b>{promo.expirationDate}</b></span>} and
                get <b><PromoValue promo={promo} /> off</b> using the code{' '}
                <b className="u-type--uppercase">{promo.code}</b>.
              </div>
              <div className="u-mt u-mb-">
                <a
                  role="button"
                  tabIndex={0}
                  onClick={goToBookAppointment}
                  className="c-campaign-email__button"
                  style={{ color }}
                >
                  Book An Appointment
                </a>
              </div>
            </div>
          )}
        </div>
        <div className="c-campaign-email__footer u-mt">
          <div className="u-type--semibold">{shopName}</div>
          <div>{shopAddress}</div>
          <Link to={unsubscribeUrl}>Unsubscribe</Link>
        </div>
      </div>
    )}
  </div>
);

CampaignEmail.propTypes = {
  loading: PropTypes.bool.isRequired,
  logo: PropTypes.string,
  shopName: PropTypes.string,
  shopAddress: PropTypes.string,
  backgroundImage: PropTypes.string,
  color: PropTypes.string,
  subject: PropTypes.string,
  body: PropTypes.string,
  promo: PropTypes.shape({
    code: PropTypes.string,
    value: PropTypes.number,
    expirationDate: PropTypes.string,
  }),
  unsubscribeUrl: PropTypes.string,
  goToBookAppointment: PropTypes.func.isRequired,
};
CampaignEmail.defaultProps = {
  logo: '',
  shopName: '',
  shopAddress: '',
  backgroundImage: '',
  color: '',
  subject: '',
  body: '',
  promo: {},
  unsubscribeUrl: '',
};

export default CampaignEmail;



// WEBPACK FOOTER //
// ./src/app/campaign/components/CampaignEmail.jsx